module.exports = __webpack_public_path__ + "img/doble.f0ffb5a4.svg";